// import React, { useState } from "react";
// import Chart from "react-apexcharts";
// import { DatePicker } from "antd";
// import dayjs from "dayjs";

// const { RangePicker } = DatePicker;

// const initialData = [
//   { date: "2024-03-01", listeners: 20, completed: 25 },
//   { date: "2024-03-02", listeners: 40, completed: 30 },
//   { date: "2024-03-03", listeners: 35, completed: 45 },
//   { date: "2024-03-04", listeners: 80, completed: 70 },
//   { date: "2024-03-05", listeners: 60, completed: 50 },
// ];

// const BarChartComp = () => {
//   const [filteredData, setFilteredData] = useState(initialData);

//   const handleDateChange = (dates) => {
//     if (!dates || dates.length === 0) {
//       setFilteredData(initialData); // Reset to full data if no selection
//       return;
//     }

//     const [start, end] = dates.map((date) => date.format("YYYY-MM-DD"));
//     const newData = initialData.filter(
//       (item) => item.date >= start && item.date <= end
//     );
//     setFilteredData(newData);
//   };

//   const chartOptions = {
//     chart: {
//       id: "bar-chart",
//       toolbar: { show: false },
//     },
//     xaxis: {
//       type: "datetime",
//       categories: filteredData.map((item) => item.date),
//     },
//     title: {
//       text: "Total Play Comparison",
//       align: "left",
//     },
//     plotOptions: {
//       bar: {
//         borderRadius: 5,
//         horizontal: false,
//         columnWidth: "50%",
//       },
//     },
//     dataLabels: {
//       enabled: false,
//     },
//   };

//   const chartSeries = [
//     {
//       name: "Listeners",
//       data: filteredData.map((item) => item.listeners),
//     },
//     {
//       name: "Completed",
//       data: filteredData.map((item) => item.completed),
//     },
//   ];

//   return (
//     <div>
//       <RangePicker
//         onChange={handleDateChange}
//         format="YYYY-MM-DD"
//         defaultValue={[dayjs("2024-03-01"), dayjs("2024-03-05")]}
//         style={{ marginBottom: 20 }}
//       />
//       <Chart
//         options={chartOptions}
//         series={chartSeries}
//         type="bar"
//         height={350}
//       />
//     </div>
//   );
// };

// export default BarChartComp;

import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategoryPodcastListener } from "../../../redux/reducer/dashboardSlice";


const { RangePicker } = DatePicker;

// Example Data for 8 Categories
const initialData = [
  { category: "Category 1", listeners: 20, completed: 25 },
  { category: "Category 2", listeners: 40, completed: 30 },
  { category: "Category 3", listeners: 35, completed: 45 },
  { category: "Category 4", listeners: 80, completed: 70 },
  { category: "Category 5", listeners: 60, completed: 50 },
  { category: "Category 6", listeners: 45, completed: 55 },
  { category: "Category 7", listeners: 30, completed: 35 },
  { category: "Category 8", listeners: 50, completed: 65 },
];

const BarChartComp = ({tenantId}) => {
  const [filteredData, setFilteredData] = useState(initialData);
  const dispatch = useDispatch()
  const {dashboardCategoryLisnersData} = useSelector((prev) => prev.dashboard)

 

  const transformedData = dashboardCategoryLisnersData?.map(item => ({
    category: item?.category_name_en,
    listeners: Number(item?.listener_count),
    completed: Number(item?.complete_count)
  }));


  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const truncateLength = screenWidth < 600 ? 10 :  (screenWidth < 900 ? 13 : screenWidth < 1200  ? 22 : screenWidth < 1480  ? 10 : screenWidth < 2000  ?  28 : 22);

  
 
  // const handleDateChange = (dates) => {
  //   if (!dates || dates?.length === 0) {
  //     setFilteredData(initialData); // Reset to full data if no selection
  //     return;
  //   }

  //   // Since we removed dates, you can modify this function to filter categories differently
  //   setFilteredData(initialData); // Keep all categories for now
  // };



  useEffect(()=>{
    let payload = {}
    if(tenantId === null){
      payload = {}
    }else{
      payload = {
        tenant_id: tenantId,
      }
    }

    dispatch(fetchCategoryPodcastListener(payload))
  },[dispatch, tenantId])


  const handleDateChange = (dates) => {
    if (!dates || dates.length === 0) return;
  
    const [start, end] = dates.map((date) => date.format("YYYY/MM/DD")); // Format as per API
    let payload = {}
    if(tenantId === null){
      payload = {
        from_date: start,
        to_date: end,
      }
    }else{
      payload = 
      
      {
        from_date: start,
        to_date: end,
        tenant_id: tenantId,
      }
    }
  
    dispatch(fetchCategoryPodcastListener(payload));
  };

  const chartOptions = {
    chart: {
      id: "bar-chart",
      toolbar: { show: false },
    },
    grid: {
      padding: {
        left: 20, // Increase this if needed
      },
    },
    // xaxis: {
    //   categories: transformedData?.map((item) => item.category.length > 22 ? item.category.slice(0,22)+"..." :  item.category  ), // Use categories instead of dates
    // },
    xaxis: {
      categories: transformedData?.map((item) =>
        item.category.length > truncateLength
          ? item.category.slice(0, truncateLength) + "..."
          : item.category
      ),
    },
    // title: {
    //   text: "Category-wise Comparison",
    //   align: "left",
    // },
    plotOptions: {
      bar: {
        borderRadius: 5,
        horizontal: false,
        columnWidth: "50%",
      },
    },
    dataLabels: {
      enabled: false,
    },
  };

  const chartSeries = [
    {
      name: "Listeners",
      data: transformedData?.map((item) => item.listeners),
    },
    {
      name: "Completed",
      data: transformedData?.map((item) => item.completed),
    },
  ];

  return (
    <div>
      {/* <RangePicker
        onChange={handleDateChange}
        format="YYYY-MM-DD"
        // defaultValue={[dayjs("2024-03-01"), dayjs("2024-03-05")]}
        defaultValue={[dayjs().startOf("month"), dayjs()]}
        style={{ marginBottom: 20 }}
      /> */}
      <Chart
        options={chartOptions}
        series={chartSeries}
        type="bar"
        height={350}
      />
    </div>
  );
};

export default BarChartComp;
    
